import styled from "styled-components";
import { space } from "styled-system";
import { Svg } from "react-native-svg";

export const StyledSVG = styled(Svg)`
  ${space}
`;
